// db.ts
import Dexie, { Table } from 'dexie';

export interface tags {
  id?: number;
  title: string;
  note_id: number
}
export interface notes {
  id?: number;
  title: string;
  content: string;
  last_updated: string
}
export interface metadata {
    id?: number;
    note_id: number;
    metakey: string;
    metavalue: string;
}
export interface config {
    id?: number;
    configkey: string;
    configvalue: string;
}
export interface folders {
    id?: number;
    name: string;
}

export class AppDB extends Dexie {
  notes!: Table<notes, number>;
  tags!: Table<tags, number>;
  metadata!: Table<metadata, number>;
  config!: Table<config, number>;
  folders!: Table<folders, number>;

  constructor() {
    super('ngdexieliveQuery');
    this.version(3).stores({
      notes: '++id',
      tags: '++id, note_id',
      metadata: '++id, note_id',
      config: '++id',
      folders: '++id, name'
    });

    this.on('populate', () => this.populate());
  }

  async populate() {
    const note_id = await db.notes.add({
      title: 'Untitled Note',
      last_updated: (new Date).toString(),
      content: `---\n\
title: Untitled Note\n\
---\n\n# {{title}}`
    });
    console.log(note_id);
  }
}

export const db = new AppDB();